module.exports = __webpack_public_path__ + "static/media/fixRoller.d78fe000.png";